import React, { useContext, useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

import LoadingWrapper from '../../../sharedModules/layout/LoadingWrapper';
import PageHeader from '../../../sharedModules/layout/PageHeader';
import { SnackBarContext } from '../../../sharedModules/form/contexts/SnackBarContext';
import axios from '../../../sharedModules/utils/axios.utils';
import InspectionReportFormPage from '../../inspectionReport/pages/InspectionReportFormPage';
import type { InspectionFormValues } from '../../inspectionReport/pages/InspectionReportFormPage';

const UpcomingJobFillPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const { showSuccessSnackBar } = useContext(SnackBarContext);
  const [prefillData, setPrefillData] = useState<Partial<InspectionFormValues> | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchJob = async () => {
      if (!id) return;
      setLoading(true);
      setError('');
      try {
        const response: any = await axios.get(`/home_services/inspection_jobs/${id}`);
        const data = response?.data;
        setPrefillData({
          customerName: data.customer_name || '',
          date: data.scheduled_date || '',
          technician: data.emp_id || '',
          workOrderNumber: data.order_no || '',
        });
      } catch (err: any) {
        setError(err?.response?.data?.error || err?.response?.data?.message || 'Failed to load job');
      } finally {
        setLoading(false);
      }
    };
    fetchJob();
  }, [id]);

  const handleSubmitSuccess = () => {
    showSuccessSnackBar?.('Inspection report submitted successfully!');
    history.push('/home_services/upcoming_inspections');
  };

  if (loading) {
    return <LoadingWrapper isLoading />;
  }

  if (error) {
    return (
      <Box sx={{ p: 3, maxWidth: 1200, margin: '0 auto' }}>
        <PageHeader
          mainTitle="Home Inspections"
          subTitle="Fill Inspection Report"
          backButtonLabel="Back to Today's Inspections"
          backButtonLink="/home_services/upcoming_inspections"
        />
        <Typography color="error" sx={{ mt: 2 }}>
          {error}
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <Box sx={{ px: 3, pt: 3, maxWidth: 1200, margin: '0 auto' }}>
        <PageHeader
          mainTitle="Home Inspections"
          subTitle="Fill Inspection Report"
          backButtonLabel="Back to Today's Inspections"
          backButtonLink="/home_services/upcoming_inspections"
        />
      </Box>
      {prefillData && (
        <InspectionReportFormPage
          homeInspectionJobId={id}
          prefillData={prefillData}
          headerDisabled
          title="Inspection Report"
          onSubmitSuccess={handleSubmitSuccess}
        />
      )}
    </>
  );
};

export default UpcomingJobFillPage;
